import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(planner-screens)/job-order/review-step"
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/(planner-screens)/job-order/review-step"!</div>;
}
